import dynamic from 'next/dynamic';

const RangeSelectorDynamic = dynamic(() => import('./RangeSelector'));

export default RangeSelectorDynamic;
